/* eslint-disable no-case-declarations */
import uuidv4 from "uuid/v4";
import {
  ADD_IMAGE,
  ADD_IMAGES,
  UPDATE_IMAGE_STATE,
  CLEAR_IMAGES
} from "../actions/types";

const initialState = [];
export default (state = initialState, action) => {
  let images = [];
  let uid, url, type;
  switch (action.type) {
    case ADD_IMAGE:
      images = [...state];
      uid = action.payload.uid;
      url = action.payload.url;
      type = action.payload.type;
      images.push({
        url,
        uid,
        type,
        isCropped: false
      });
      return images;

    case ADD_IMAGES:
      images = [...state];
      if (Array.isArray(action.payload.images)) {
        images = [...images, ...action.payload.images];
        type = action.payload.type;
      } else {
        if (action.payload.images) images.push(action.payload.images);
      }
      images.forEach(image => {
        image.uid = uuidv4();
        image.type = image.type || type;
      });
      return images;

    case UPDATE_IMAGE_STATE:
      images = [...state];
      uid = action.payload.uid;
      let { isCropped } = action.payload;
      let index = images.findIndex(image => image.uid === uid);
      images[index].isCropped = isCropped;
      return images;

    case CLEAR_IMAGES:
      images = [...state];
      type = action.payload.type;
      images = type ? images.filter(image => image.type !== type) : [];
      return images;

    default:
      return state;
  }
};
